import React, { memo } from 'react'
import Button from 'blocks.simple/button/button'
import Catalog from 'blocks.app/catalog/catalog'
import VideoEditorSidebarMethods, { IVideoEditorSidebarMethodsProps } from './videoEditor__sidebar.local.methods'
import Icon from 'blocks.simple/icon/icon'
import EditText from 'blocks.simple/editText/editText'
import Checkbox from 'blocks.simple/checkbox/checkbox'
import Dropdown from 'blocks.simple/dropdown/dropdown'

import deepEqual from 'fast-deep-equal'
import moment from 'moment'
import helpers from 'core/helpers'
import helpersFiles from 'core/helpers/_files/index'
import translate from 'core/translate'
import { mediaJS } from 'blocks.app/config'

import { cn } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import styles from './videoEditor__sidebar.jcss'
import item from 'blocks.simple/item/item.jcss'
import { Typography } from 'atoms/Typography'
import { defaultThemeStyles as defaultThemeSidebarStyles } from 'blocks.app/sidebar/Sidebar-theme'
import { SwitchButton } from '../../../atoms/SwitchButton'
import { text as textStyles } from 'theme'
import { useDispatch } from 'react-redux'
import {
    audioCodecOptions,
    codecPresetOptions,
    codecProfileOptions,
    presetsOptions,
    videoCodecOptions,
} from 'pages/settings/__downloadVideoOptions/settings___downloadVideoOptions'
import Colorpicker from '../../../blocks.simple/colorpicker/colorpicker'
import { editor } from '../../editor/editor.local.methods'

const degrees = [
    { id: 0, name: '0' },
    { id: 90, name: '90' },
    { id: 180, name: '180' },
    { id: 270, name: '270' },
]
const bitRate = [
    { id: 1000, name: '360p' },
    { id: 2500, name: '480p' },
    { id: 5000, name: '720p' },
    { id: 8000, name: '1080p' },
    { id: 16000, name: '1440p' },
    { id: 40000, name: '2160p' },
]
const bitRateValues = bitRate.map((item) => item.id)

const getShowSettingsHeaderIcon = (type: string) => {
    switch (type) {
        case 'edit':
            return 'pencil'
        default:
            return 'gear'
    }
}

const codecCrfOptions: { id: number; name: number }[] = []

for (let i = 0; i <= 51; i++) {
    codecCrfOptions.push({
        id: i,
        name: i,
    })
}

const codecLevelOptions: { id: number; name: number }[] = []

for (let major = 1; major <= 5; major++) {
    for (let minor = 0; minor <= 9; minor++) {
        if (major === 5 && minor > 1) break // до 5.1 включительно
        const level = parseFloat(`${major}.${minor}`)
        codecLevelOptions.push({
            id: level,
            name: level,
        })
    }
}

function convertBinaryToBase64(file: File): Promise<string[]> {
    return new Promise((resolve, reject) => {
        const reader: FileReader = new FileReader()
        reader.onload = () => {
            if (reader && reader.result) {
                if (typeof reader.result === 'string') {
                    const base64String: string[] = reader.result.split(',')

                    base64String.push(file.name)

                    resolve(base64String)
                }
            }
        }
        reader.onerror = (error) => reject(error)
        reader.readAsDataURL(file)
    })
}

const VideoEditorSidebar = (props: IVideoEditorSidebarMethodsProps) => {
    const {
        state,
        calculateProportions,
        isButtonCheckedAndDisabled,
        onChangeCrop,
        onChangeNumberField,
        setDisabledTaskMultiSelect,
        setState,
        setActiveToggle,
    } = VideoEditorSidebarMethods(props)

    let dragTimer: any = null
    const p_ = props
    const s_ = { ...state }
    const disableProcessButton = deepEqual(p_.commands, p_.defaultCommands)
    const activeToolbarColor = `var(--var-module-sidebar-component-sidebar-style-activeToggleText, ${defaultThemeSidebarStyles.activeToggleText})`
    const notActiveToolbarColor = `var(--var-module-sidebar-component-sidebar-style-toggleText, ${defaultThemeSidebarStyles.toggleText})`

    const showAddContentButtons = () => {
        if (props.isMobile) {
            return true
        }
        return !!state.selectedItem
    }

    return (
        <div
            ref={props.videoEditorSidebarRef}
            style={p_.minimized ? { width: '58px', overflow: 'hidden' } : { width: '33.3333333%' }}
            className={cn(styles.colsRight, { [styles.colsRightOpen]: !p_.minimized })}
        >
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    <div
                        onClick={function () {
                            p_.toggleMinimized()
                        }}
                        className={styles.minimize}
                    >
                        <Icon size={16} type={p_.minimized ? 'double_arrow_left' : 'double_arrow_right'} />
                    </div>
                    {!p_.minimized && (
                        <div className={grid.spaceWidth}>
                            {!p_.showSettings && (
                                <div className={styles.toggle}>
                                    <div
                                        className={cn(grid.col2, styles.toggleItem, {
                                            [styles.toggleItemActive]: s_.activeToggle === 'tasks',
                                            [styles.toggleItemDisable]: s_.activeToggle !== 'tasks',
                                        })}
                                        onClick={() => {
                                            setState((prevState) => {
                                                return {
                                                    ...prevState,
                                                    activeToggle: 'tasks',
                                                }
                                            })
                                        }}
                                    >
                                        <div className={grid.rowCenter}>
                                            <Icon
                                                type={'list'}
                                                color={
                                                    s_.activeToggle === 'tasks'
                                                        ? activeToolbarColor
                                                        : notActiveToolbarColor
                                                }
                                            />
                                            <div className={grid.ml_micro}>{translate('tasks')}</div>
                                        </div>
                                    </div>
                                    <div
                                        className={cn(grid.col2, styles.toggleItem, {
                                            [styles.toggleItemActive]: s_.activeToggle === 'files',
                                        })}
                                        onClick={() => {
                                            setState((prevState) => {
                                                return {
                                                    ...prevState,
                                                    activeToggle: 'files',
                                                    activeProcess: 0,
                                                }
                                            })
                                        }}
                                    >
                                        <div className={grid.rowCenter}>
                                            <Icon
                                                type={'folder'}
                                                color={
                                                    s_.activeToggle === 'files'
                                                        ? activeToolbarColor
                                                        : notActiveToolbarColor
                                                }
                                            />
                                            <div className={grid.ml_micro}>{translate('files')}</div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {p_.showSettings && (
                                <div className={styles.toggle}>
                                    <div className={cn(grid.fullWidth, styles.toggleItem, styles.toggleItemActive)}>
                                        <div className={grid.rowCenter}>
                                            <Icon type={getShowSettingsHeaderIcon(p_.showSettings)} />
                                            <div className={grid.ml_micro}>
                                                {p_.showSettings === 'edit'
                                                    ? translate(`${p_.media.type}Editing`)
                                                    : translate('settings')}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className={styles.contentWrapper}>
                    <div
                        className={styles.content}
                        style={s_.activeToggle === 'tasks' && !p_.showSettings ? {} : { display: 'none' }}
                    >
                        <div className={cn(styles.catalogWrapper, grid.mt_md)}>
                            <Catalog
                                searchbarMod={'withShadow'}
                                key={'catalog_videoEditorTasks'}
                                type={'videoEditorTasks'}
                                selectedInfo={p_.media}
                                onSelectInfo={p_.onSelectTask}
                                selectedItems={p_.selectedTasks}
                                onSelect={p_.onSelectTasks}
                                disableMultiSelect={setDisabledTaskMultiSelect}
                                onChange={function (item: any, type: string) {
                                    p_.onChangeTask(item, type)
                                }}
                                treeView={false}
                                useWindow={false}
                            />
                        </div>
                    </div>
                    <div
                        className={styles.content}
                        style={s_.activeToggle === 'files' && !p_.showSettings ? {} : { display: 'none' }}
                    >
                        <div
                            className={styles.catalogWrapper}
                            onClick={function () {
                                p_.openMinimized()
                            }}
                        >
                            <Catalog
                                type={'files'}
                                searchbarMod={'withShadow'}
                                small={true}
                                useWindow={false}
                                cols={4}
                                hideHeader={p_.minimized}
                                classNameContent={cn({ [item.none]: p_.minimized })}
                                showHeaderButton={false}
                                disposition={'tile'}
                                selectedInfo={s_.selectedItem}
                                filterItems={[
                                    { name: translate('all') },
                                    { name: translate('video'), fileType: 'video', type: 'fs' },
                                    { name: translate('image'), fileType: 'image', type: 'fs' },
                                ]}
                                onDragStart={() => {
                                    if (mediaJS.tabMini.matches) {
                                        clearTimeout(dragTimer)
                                        dragTimer = setTimeout(() => {
                                            p_.toggleMinimized()
                                        }, 300)
                                    }
                                }}
                                onDragEnd={() => {
                                    if (mediaJS.tabMini.matches) {
                                        clearTimeout(dragTimer)
                                    }
                                }}
                                disableFolderSelection={true}
                                isMobileDragEnabled
                                onSelectInfo={(item: any) => {
                                    setState((prevState) => {
                                        return {
                                            ...prevState,
                                            selectedItem: item,
                                        }
                                    })
                                }}
                            />
                        </div>
                        {showAddContentButtons() && (
                            <div className={styles.multiSelectionPanel}>
                                <Button
                                    mod={'fill'}
                                    className={styles.contentBtn}
                                    onClick={() => {
                                        setState((prevState) => {
                                            return {
                                                ...prevState,
                                                selectedItem: null,
                                            }
                                        })
                                    }}
                                >
                                    {translate('cancel')}
                                </Button>
                                <Button
                                    mod={'withBorder'}
                                    className={styles.contentBtn}
                                    disabled={!s_.selectedItem}
                                    onClick={() => {
                                        if (!s_.selectedItem) {
                                            return
                                        }

                                        props.onSave({
                                            id: s_.selectedItem.id,
                                            isDirectory: s_.selectedItem.isDirectory,
                                        })
                                    }}
                                >
                                    {translate('add')}
                                </Button>
                            </div>
                        )}
                    </div>
                    {p_.showSettings === 'edit' && p_.media.type === 'video' && (
                        <div className={styles.content}>
                            <div>
                                <Typography className={styles.title} type="title">
                                    {translate('duration')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <EditText
                                        value={p_.commands.cut.startTime}
                                        label={translate('startTime')}
                                        containerClass={cn(grid.w45, grid.mr_md)}
                                        mask={'99:99:99'}
                                        onChange={function (value: number | string) {
                                            const data = helpers.deepCopy(p_.commands)

                                            data.cut.startTime = String(value)
                                            p_.onChangeCommands(data)
                                        }}
                                        onBlur={function (value: number | string) {
                                            if (!moment(value, 'HH:mm:ss', true).isValid()) {
                                                const data = helpers.deepCopy(p_.commands)

                                                data.cut.startTime = ''
                                                p_.onChangeCommands(data)
                                            }
                                        }}
                                    />
                                    <EditText
                                        value={p_.commands.cut.duration}
                                        label={translate('endTime')}
                                        containerClass={cn(grid.w45)}
                                        mask={'99:99:99'}
                                        onChange={function (value: number | string) {
                                            const data = helpers.deepCopy(p_.commands)

                                            data.cut.duration = String(value)
                                            p_.onChangeCommands(data)
                                        }}
                                        onBlur={function (value: number | string) {
                                            const data = helpers.deepCopy(p_.commands)

                                            if (!moment(value, 'HH:mm:ss', true).isValid()) {
                                                data.cut.duration = ''
                                                p_.onChangeCommands(data)
                                            }
                                        }}
                                    />
                                </div>
                                <div
                                    className={cn(
                                        styles.settingsContent,
                                        grid.pb_mini,
                                        grid.pt_md,
                                        grid.row,
                                        grid.justify,
                                        styles.inputWidth
                                    )}
                                >
                                    <span className={styles.spanWidth}>{translate('trimVideoOption')}</span>
                                    <div>
                                        <SwitchButton
                                            onChange={() => {
                                                {
                                                    const data = helpers.deepCopy(p_.commands)

                                                    data.cut.trim = !p_.commands.cut.trim
                                                    p_.onChangeCommands(data)
                                                }
                                            }}
                                            checked={p_.commands.cut.trim}
                                        />
                                    </div>
                                </div>
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('size')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <EditText
                                        mod={'withBorder'}
                                        value={p_.commands.crop.width}
                                        label={translate('width')}
                                        containerClass={cn(grid.w45, grid.mr_md)}
                                        type="number"
                                        onChange={(value: number) => {
                                            onChangeCrop('width', value)
                                        }}
                                    />
                                    <EditText
                                        mod={'withBorder'}
                                        value={p_.commands.crop.height}
                                        label={translate('height')}
                                        containerClass={cn(grid.w45)}
                                        type="number"
                                        onChange={(value: number) => {
                                            onChangeCrop('height', value)
                                        }}
                                    />
                                </div>
                                {!p_.media.multiple && (
                                    <div className={styles.settingsContent}>
                                        <Checkbox
                                            label={translate('keepProportions')}
                                            checked={s_.keepProportions}
                                            onClick={(checked: boolean) => {
                                                if (checked) {
                                                    calculateProportions()
                                                }
                                                setState((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        keepProportions: checked,
                                                    }
                                                })
                                            }}
                                        />
                                    </div>
                                )}
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('conversion')}
                                </Typography>
                                {p_.media.mimetype !== 'video/mp4' && (
                                    <div style={{ paddingBottom: 0 }} className={styles.settingsContent}>
                                        <Checkbox
                                            disabled={!isButtonCheckedAndDisabled(p_.media.mimetype)}
                                            label={translate('covertVideoToMp4')}
                                            checked={
                                                !isButtonCheckedAndDisabled(p_.media.mimetype)
                                                    ? true
                                                    : p_.commands.convertToMp4.active
                                            }
                                            onClick={function (checked: boolean) {
                                                if (helpersFiles.availableVideoMimeTypes(p_.media.mimetype)) {
                                                    const data = helpers.deepCopy(p_.commands)

                                                    data.convertToMp4.active = checked
                                                    p_.onChangeCommands(data)
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                                <Typography className={styles.subTitle} type="title">
                                    {translate('bitRate')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <EditText
                                        value={p_.commands.setVideoBitrate.bitrate}
                                        label={translate('customBitRate')}
                                        containerClass={cn(grid.w45)}
                                        onChange={(value: number) => {
                                            onChangeNumberField(value, 'setVideoBitrate', 'bitrate')
                                        }}
                                    />
                                    <Dropdown
                                        containerClassName={cn(grid.w45)}
                                        label={translate('availableBitRate')}
                                        value={
                                            bitRateValues.includes(Number(p_.commands.setVideoBitrate.bitrate))
                                                ? p_.commands.setVideoBitrate.bitrate
                                                : null
                                        }
                                        options={bitRate}
                                        onChange={function (bitrate) {
                                            const data = helpers.deepCopy(p_.commands)

                                            data.setVideoBitrate.bitrate = bitrate.id
                                            p_.onChangeCommands(data)
                                        }}
                                    />
                                </div>
                                <Typography className={styles.subTitle} type="title">
                                    {translate('fps')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <EditText
                                        value={p_.commands.setFps.fps}
                                        containerClass={cn(grid.w45)}
                                        onChange={(value: number) => {
                                            onChangeNumberField(value, 'setFps', 'fps')
                                        }}
                                    />
                                </div>
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('rotate')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <Dropdown
                                        containerClassName={cn(grid.w45)}
                                        value={p_.commands.rotate.degrees}
                                        options={degrees}
                                        onChange={function (degree) {
                                            const data = helpers.deepCopy(p_.commands)
                                            if (degree.id === 90 || degree.id === 270) {
                                                if (data.rotate.degrees === 0 || data.rotate.degrees === 180) {
                                                    const prevCrop = { ...data.crop }
                                                    data.crop = { width: prevCrop.height, height: prevCrop.width }
                                                }
                                            }
                                            if (degree.id === 0 || degree.id === 180) {
                                                if (data.rotate.degrees === 90 || data.rotate.degrees === 270) {
                                                    const prevCrop = { ...data.crop }
                                                    data.crop = { width: prevCrop.height, height: prevCrop.width }
                                                }
                                            }
                                            data.rotate.degrees = degree.id
                                            p_.onChangeCommands(data)
                                        }}
                                    />
                                </div>
                                <div className={styles.description}>{translate('rotateClockwise')}</div>
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('sound')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <Checkbox
                                        label={translate('deleteSoundFromVideo')}
                                        checked={p_.commands.removeAudio.active}
                                        onClick={function (checked: boolean) {
                                            const data = helpers.deepCopy(p_.commands)

                                            data.removeAudio.active = checked
                                            p_.onChangeCommands(data)
                                        }}
                                    />
                                </div>
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('subtitles')}
                                </Typography>
                                <div style={{ position: 'relative' }}>
                                    {!p_.commands.subtitles.file ? (
                                        <div>
                                            <div className={styles.filePickerWrapper}>
                                                <label className={styles.label} htmlFor="fileUpload">
                                                    {translate('chooseFileSubtitles')}
                                                </label>
                                                <input
                                                    id="fileUpload"
                                                    accept=".srt"
                                                    type="file"
                                                    className={styles.input}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        if (e.target.files && e.target.files.length) {
                                                            convertBinaryToBase64(e.target.files[0]).then((file) => {
                                                                const data = helpers.deepCopy(p_.commands)

                                                                data.subtitles = {
                                                                    ...data.subtitles,
                                                                    file,
                                                                }

                                                                p_.onChangeCommands(data)
                                                            })
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={styles.fileSelected}>
                                            <Icon type={'attached'} size={16} />
                                            <div className={styles.fileName}>{p_.commands.subtitles.file[2]}</div>
                                            <Icon
                                                type={'delete'}
                                                size={16}
                                                containerClass={styles.deleteFile}
                                                onClick={() => {
                                                    const data = helpers.deepCopy(p_.commands)

                                                    data.subtitles.file = null
                                                    p_.onChangeCommands(data)
                                                }}
                                            />
                                        </div>
                                    )}
                                    {p_.commands.subtitles.file && (
                                        <>
                                            <div className={styles.settingsContent}>
                                                <Dropdown
                                                    containerClassName={cn(grid.w45)}
                                                    label={translate('fontFamily')}
                                                    value={p_.commands.subtitles.fontId}
                                                    options={s_.fonts}
                                                    onChange={function (font) {
                                                        const data = helpers.deepCopy(p_.commands)

                                                        data.subtitles.fontId = font.id
                                                        p_.onChangeCommands(data)
                                                    }}
                                                />
                                                <EditText
                                                    value={p_.commands.subtitles.fontSize}
                                                    label={translate('fontSize')}
                                                    containerClass={cn(grid.w45)}
                                                    onChange={(value: string) => {
                                                        const data = helpers.deepCopy(p_.commands)

                                                        data.subtitles.fontSize = value
                                                        p_.onChangeCommands(data)
                                                    }}
                                                />
                                            </div>
                                            <div className={styles.colors}>
                                                <div className={styles.color}>
                                                    <div className={styles.colorLabel}>
                                                        {translate('subtitlesColor')}
                                                    </div>
                                                    <Colorpicker
                                                        title={translate('subtitlesColor')}
                                                        color={p_.commands.subtitles.color}
                                                        onChange={(value) => {
                                                            const data = helpers.deepCopy(p_.commands)

                                                            data.subtitles.color = value
                                                            p_.onChangeCommands(data)
                                                        }}
                                                        className={''}
                                                        style={{}}
                                                    />
                                                </div>
                                                <div className={styles.color}>
                                                    <div className={styles.colorLabel}>
                                                        {translate('subtitlesOutlineColor')}
                                                    </div>
                                                    <Colorpicker
                                                        title={translate('subtitlesOutlineColor')}
                                                        color={p_.commands.subtitles.outlineColor}
                                                        onChange={(value) => {
                                                            const data = helpers.deepCopy(p_.commands)

                                                            data.subtitles.outlineColor = value
                                                            p_.onChangeCommands(data)
                                                        }}
                                                        className={''}
                                                        style={{}}
                                                    />
                                                </div>
                                            </div>
                                            <div className={styles.settingsContent}>
                                                <Dropdown
                                                    containerClassName={cn(grid.w45)}
                                                    label={translate('outlineType')}
                                                    value={p_.commands.subtitles.outlineType}
                                                    options={[
                                                        {
                                                            name: translate('outlineColor'),
                                                            id: 'outline',
                                                        },
                                                        {
                                                            name: translate('boxColor'),
                                                            id: 'box',
                                                        },
                                                    ]}
                                                    onChange={function (outlineType) {
                                                        const data = helpers.deepCopy(p_.commands)

                                                        data.subtitles.outlineType = outlineType.id
                                                        p_.onChangeCommands(data)
                                                    }}
                                                />
                                                <EditText
                                                    type={'number'}
                                                    value={p_.commands.subtitles.outlineSize}
                                                    label={translate('outlineSize')}
                                                    containerClass={cn(grid.w45)}
                                                    onChange={(value: string) => {
                                                        const data = helpers.deepCopy(p_.commands)

                                                        data.subtitles.outlineSize = +value
                                                        p_.onChangeCommands(data)
                                                    }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('preset')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <Checkbox
                                        label={translate('usePreset')}
                                        checked={p_.usePreset}
                                        onClick={function (checked: boolean) {
                                            p_.onChangeUsePreset(checked)
                                        }}
                                    />
                                </div>
                                {p_.usePreset && (
                                    <Dropdown
                                        containerClassName={cn(textStyles.center, styles.inputWidth_L, grid.pb_mini)}
                                        value={p_.presetType}
                                        options={presetsOptions}
                                        centered
                                        onChange={(value) => {
                                            p_.setPresetType(value.id)
                                        }}
                                        dropDirection={'up'}
                                    />
                                )}
                            </div>
                            {p_.presetType === 0 && (
                                <div>
                                    <div className={styles.settingsContent}>
                                        <Dropdown
                                            containerClassName={cn(textStyles.center, styles.inputWidth, grid.pb_mini)}
                                            label={translate('videoCodec')}
                                            value={p_.commands.videoCodec.videoCodec}
                                            options={videoCodecOptions}
                                            centered
                                            onChange={(value) => {
                                                const data = helpers.deepCopy(p_.commands)

                                                data.videoCodec.videoCodec = value.name
                                                p_.onChangeCommands(data)
                                            }}
                                        />
                                    </div>
                                    <div className={styles.settingsContent}>
                                        <Dropdown
                                            containerClassName={cn(textStyles.center, styles.inputWidth, grid.pb_mini)}
                                            label={translate('audioCodec')}
                                            value={p_.commands.audioCodec.audioCodec}
                                            options={audioCodecOptions}
                                            centered
                                            onChange={(value) => {
                                                const data = helpers.deepCopy(p_.commands)

                                                data.audioCodec.audioCodec = value.name
                                                p_.onChangeCommands(data)
                                            }}
                                        />
                                    </div>
                                    <div className={styles.settingsContent}>
                                        <Dropdown
                                            containerClassName={cn(textStyles.center, styles.inputWidth, grid.pb_mini)}
                                            label={translate('codecProfile')}
                                            value={p_.commands.profile.profile}
                                            options={codecProfileOptions}
                                            centered
                                            onChange={(value) => {
                                                const data = helpers.deepCopy(p_.commands)

                                                data.profile.profile = value.name
                                                p_.onChangeCommands(data)
                                            }}
                                        />
                                    </div>
                                    <div className={styles.settingsContent}>
                                        <Dropdown
                                            containerClassName={cn(textStyles.center, styles.inputWidth, grid.pb_mini)}
                                            label={translate('codecLevel')}
                                            value={p_.commands.level.level}
                                            options={codecLevelOptions}
                                            centered
                                            onChange={(value) => {
                                                const data = helpers.deepCopy(p_.commands)

                                                data.level.level = value.name
                                                p_.onChangeCommands(data)
                                            }}
                                        />
                                    </div>
                                    <div className={styles.settingsContent}>
                                        <Dropdown
                                            containerClassName={cn(textStyles.center, styles.inputWidth, grid.pb_mini)}
                                            label={translate('preset')}
                                            value={p_.commands.preset?.preset}
                                            options={codecPresetOptions}
                                            centered
                                            onChange={(value) => {
                                                const data = helpers.deepCopy(p_.commands)

                                                data.preset.preset = value.name
                                                p_.onChangeCommands(data)
                                            }}
                                        />
                                    </div>
                                    <div
                                        className={cn(
                                            grid.pb_mini,
                                            grid.row,
                                            grid.justify,
                                            styles.settingsContent,
                                            styles.greyText
                                        )}
                                    >
                                        {translate('setForFfmpeg')}
                                    </div>
                                    <div className={styles.settingsContent}>
                                        <Dropdown
                                            containerClassName={cn(textStyles.center, styles.inputWidth, grid.pb_mini)}
                                            label={translate('crf')}
                                            value={p_.commands.crf.crf}
                                            options={codecCrfOptions}
                                            centered
                                            onChange={(value) => {
                                                const data = helpers.deepCopy(p_.commands)

                                                data.crf.crf = value.name
                                                p_.onChangeCommands(data)
                                            }}
                                            dropDirection={'up'}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className={styles.buttonWrapper}>
                                <Button
                                    className={cn(grid.mr_md)}
                                    rounded="full_md"
                                    mod="fill"
                                    onClick={setActiveToggle}
                                    disabled={
                                        disableProcessButton ||
                                        p_.media.status === 'in_queue' ||
                                        p_.media.status === 'in_progress'
                                    }
                                >
                                    {translate('process')}
                                </Button>
                                <Button
                                    rounded="full_md"
                                    animation={false}
                                    onClick={function () {
                                        p_.onChangeShowSettings(null)
                                    }}
                                >
                                    {translate('cancel')}
                                </Button>
                            </div>
                        </div>
                    )}
                    {p_.showSettings === 'edit' && p_.media.type === 'image' && (
                        <div className={styles.content}>
                            <div>
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('duration')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <EditText
                                        mod={'withBorder'}
                                        value={p_.commands.imageToVideo.duration}
                                        containerClass={cn(grid.w45)}
                                        label={translate('durationSec')}
                                        onChange={(value: number) => {
                                            onChangeNumberField(value, 'imageToVideo', 'duration')
                                        }}
                                    />
                                </div>
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('size')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <EditText
                                        mod={'withBorder'}
                                        value={p_.commands.crop.width}
                                        label={translate('width')}
                                        containerClass={cn(grid.w45, grid.mr_md)}
                                        type="number"
                                        onChange={(value: number) => {
                                            onChangeCrop('width', value)
                                        }}
                                    />
                                    <EditText
                                        mod={'withBorder'}
                                        value={p_.commands.crop.height}
                                        label={translate('height')}
                                        containerClass={cn(grid.w45)}
                                        type="number"
                                        onChange={(value: number) => {
                                            onChangeCrop('height', value)
                                        }}
                                    />
                                </div>
                                {!p_.media.multiple && (
                                    <div className={styles.settingsContent}>
                                        <Checkbox
                                            label={translate('keepProportions')}
                                            checked={s_.keepProportions}
                                            onClick={(checked: boolean) => {
                                                if (checked) {
                                                    calculateProportions()
                                                }
                                                setState((prevState) => {
                                                    return {
                                                        ...prevState,
                                                        keepProportions: checked,
                                                    }
                                                })
                                            }}
                                        />
                                    </div>
                                )}
                                <Typography className={styles.contentTitle} type="title">
                                    {translate('bitRate')}
                                </Typography>
                                <div className={styles.settingsContent}>
                                    <EditText
                                        value={p_.commands.setVideoBitrate.bitrate}
                                        label={translate('customBitRate')}
                                        containerClass={cn(grid.w45)}
                                        onChange={(value: number) => {
                                            onChangeNumberField(value, 'setVideoBitrate', 'bitrate')
                                        }}
                                    />
                                    <Dropdown
                                        containerClassName={cn(grid.w45)}
                                        label={translate('availableBitRate')}
                                        value={
                                            bitRateValues.includes(Number(p_.commands.setVideoBitrate.bitrate))
                                                ? p_.commands.setVideoBitrate.bitrate
                                                : null
                                        }
                                        options={bitRate}
                                        onChange={function (bitrate) {
                                            const data = helpers.deepCopy(p_.commands)

                                            data.setVideoBitrate.bitrate = bitrate.id
                                            p_.onChangeCommands(data)
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={styles.buttonWrapper}>
                                <Button
                                    className={cn(grid.mr_md)}
                                    rounded="full_md"
                                    mod="fill"
                                    onClick={setActiveToggle}
                                    disabled={
                                        disableProcessButton ||
                                        p_.media.status === 'in_queue' ||
                                        p_.media.status === 'in_progress'
                                    }
                                >
                                    {translate('process')}
                                </Button>
                                <Button
                                    rounded="full_md"
                                    animation={false}
                                    onClick={function () {
                                        p_.onChangeShowSettings(null)
                                    }}
                                >
                                    {translate('cancel')}
                                </Button>
                            </div>
                        </div>
                    )}
                    {p_.showSettings === 'settings' && (
                        <div className={styles.content}>
                            <div className={grid.p_md}>
                                {p_.selectedTasks.length <= 0 && (
                                    <EditText
                                        value={p_.settings.fileName}
                                        label={translate('name')}
                                        onChange={function (fileName: string) {
                                            p_.onChangeSettings(fileName, 'fileName')
                                        }}
                                    />
                                )}
                                {p_.selectedTasks.length > 0 && (
                                    <EditText
                                        value={p_.settings.fileNamePrefix}
                                        label={translate('fileNamePrefix')}
                                        onChange={function (fileNamePrefix: string) {
                                            p_.onChangeSettings(fileNamePrefix, 'fileNamePrefix')
                                        }}
                                    />
                                )}
                                <Dropdown
                                    containerClassName={cn(grid.w100, grid.mt_md)}
                                    label={translate('parentGroup')}
                                    value={p_.settings.folderId}
                                    options={s_.folders}
                                    placeholder={translate('chooseFolder')}
                                    onChange={function (folder: { [index: string]: any }) {
                                        p_.onChangeSettings(folder.id, 'folderId')
                                    }}
                                    searchable
                                    centered
                                    type="tree"
                                />
                            </div>
                            <div className={styles.buttonWrapper}>
                                <Button
                                    rounded="full_md"
                                    animation={false}
                                    onClick={function () {
                                        p_.onChangeShowSettings(null)
                                    }}
                                >
                                    {translate('close')}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default VideoEditorSidebar
